import React, { useState } from 'react';
import styled, { StylesProps, cx } from '../../../../../lib/styles';
import headerBlockStyles from './HeaderBlock_styles';
import { SignupBox } from './SignupBox';
import SearchBlock from '../../../../TravelCollection/SearchBlock';
import Carousel from '../../../../../components/presentational/Carousel/Carousel';
import CarouselItem from '../../../../../components/presentational/Carousel/CarouselItem';
import {
  NewsSlide,
  FeaturedPostSlide,
  ContentImageBackgroundSlide,
  MarketplaceProductSlide,
  BackgroundImageSlide,
} from './HeaderBlockSlides';

export interface HeaderBlockData {
  type: 'header_block';
  images: any;
  side_panel: string;
  configuration: any;
  news_articles: any;
}

export interface HeaderBlockProps {
  block: HeaderBlockData;
}

const renderSlide = (slide, styles) => {
  switch (slide.layout) {
    case 'content':
      return (
        <CarouselItem key={slide.key} layout={slide.layout}>
          <NewsSlide key={`slide-${slide.key}`} slide={slide} styles={styles} />
        </CarouselItem>
      );
    case 'full-image-panel':
      return (
        <CarouselItem key={slide.key} layout={slide.layout}>
          <BackgroundImageSlide
            key={`slide-${slide.key}`}
            slide={slide}
            styles={styles}
          />
        </CarouselItem>
      );
    case 'content-image-background':
      if (slide.post) {
        return (
          <CarouselItem key={slide.key} layout={slide.layout}>
            <FeaturedPostSlide key={`slide-${slide.key}`} slide={slide} />
          </CarouselItem>
        );
      }
      return (
        <CarouselItem key={slide.key} layout={slide.layout}>
          <ContentImageBackgroundSlide
            key={`slide-${slide.key}`}
            slide={slide}
            styles={styles}
          />
        </CarouselItem>
      );
    case 'marketplace-product':
      return (
        <CarouselItem key={slide.key} layout={slide.layout}>
          <MarketplaceProductSlide
            key={`slide-${slide.key}`}
            slide={slide}
            styles={styles}
          />
        </CarouselItem>
      );
    default:
      return (
        <CarouselItem key={slide.key} layout={slide.layout}>
          <BackgroundImageSlide
            key={`slide-${slide.key}`}
            slide={slide}
            styles={styles}
          />
        </CarouselItem>
      );
  }
};

const HeaderBlock = ({
  block: {
    images,
    side_panel,
    news_articles,
    configuration: { signup_box_image, slide_change_interval },
  },
  styles,
}) => {
  // logging.debug({ side_panel, signup_box_image, slide_change_interval }, 'HeaderBlock');

  return (
    <div className={`d-flex header-block`}>
      {side_panel === 'no_sidebar' && <></>}
      {side_panel === 'recent_news' && (
        <SignupBox
          configuration={{ signup_box_image }}
          articles={news_articles}
          styles={styles}
        />
      )}
      <Carousel
        slideInterval={
          slide_change_interval ? slide_change_interval * 1000 : 10000
        }
        location="header"
        brand="sas"
      >
        {images.map(slide => renderSlide(slide, styles))}
      </Carousel>
    </div>
  );
};

export default styled(headerBlockStyles)(HeaderBlock);
